var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-container" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.todoTitle,
            visible: _vm.visible,
            top: "5vh",
            width: "85%",
            center: "",
            "before-close": _vm.dialogBeforeClose
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.iframeLoading,
                  expression: "iframeLoading"
                }
              ],
              staticClass: "task-container-body"
            },
            [
              _vm.visible
                ? _c("iframe", {
                    ref: "iframe",
                    staticClass: "task-container-iframe",
                    attrs: { name: "iframe", src: _vm.todoUrl }
                  })
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }